import { Reducer } from '@reduxjs/toolkit';

const sortingInstructions: Reducer = (state, { payload }) => ({
  ...state,
  sortingInstructions: payload,
});

export default sortingInstructions;
